import { GlobalStyles } from '@mui/material';
import {
  EstateDetails,
  EstateDetailsWithHeaderFooterProps,
  getEstateDetailsStyles,
} from '@portals/core-immobilien/src/components';
import { trackEstateView } from '@portals/core-immobilien/src/utils';
import { SKIP_TO_MAIN_CONTENT_ANCHOR } from '@portals/root/src/components/HeaderBar/HeaderBar.constants';
import React, { useEffect } from 'react';

import HeaderFooterSection from './HeaderFooterSection/HeaderFooterSection';

export const EstateDetailsWithHeaderFooter = ({
  estate,
  pageProps,
  showBrokerContactInDrawer,
}: EstateDetailsWithHeaderFooterProps): React.ReactElement => {
  const styles = getEstateDetailsStyles();

  useEffect(() => {
    trackEstateView(estate);
  }, [estate]);

  return (
    <>
      <GlobalStyles styles={styles} />

      <HeaderFooterSection node={pageProps?.header} />

      <main id={SKIP_TO_MAIN_CONTENT_ANCHOR}>
        <EstateDetails
          estate={estate}
          showBrokerContactInDrawer={showBrokerContactInDrawer}
          injectGlobalStyles={false}
        />
      </main>

      <HeaderFooterSection node={pageProps?.footer} />
      <HeaderFooterSection node={pageProps?.legal_footer} />
    </>
  );
};

EstateDetailsWithHeaderFooter.displayName = 'EstateDetailsWithHeaderFooter';
